<template>
    <v-container>
        <form-toolbar :canEdit="canEdit" :userRoles="userRoles" :editMode="editMode"  :field="'oto'" :assignment="assignment" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class="first-row-wrapper">
                    <custom-datetime :value="localOto.appointmentDate || ''" :readOnly="true" @onSelect="appointmentDateSelected"/>
                    <v-select
                        v-model="localOto.status"
                        :items="statuses"
                        item-value="value"
                        item-text="name"
                        label="Κατάσταση"
                        outlined
                        class="field status"
                    ></v-select>
                    <v-dialog
                        v-if="this.assignment?.autopsy?.floorStructure"
                        v-model="dialog"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="white--text"
                                large
                                :color="'black'"
                                :depressed="editMode">
                                Δομη Κτιριου
                            </v-btn>
                        </template>
                        <floor-structure :editMode="false" :stored="this.assignment.autopsy.floorStructure" />
                    </v-dialog>
                </div>
                <div v-if="['PILOT', 'LAST_DROP'].includes(assignment.type)" class="oto-info">
                    <v-checkbox
                        v-model="localOto.lastDropFromBep"
                        label="Last Drop από BEP"
                        color="blue"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="localOto.lastDropFromOtherFloor"
                        label="Last Drop από άλλο Όροφο"
                        color="blue"
                    ></v-checkbox>
                    <v-checkbox
                        v-model="localOto.bigCablePath"
                        label="Εξωτερική όδευση άνω των 10m ή άνω των 40m"
                        color="blue"
                    ></v-checkbox>
                </div>
                <comments
                    ref="comments"
                    :comments="this.localOto?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode && !localOto.completed ? rules: []"
                    @new-comment="onNewComment"
                />
                <material-selection v-if="config.hasStorage" ref="material-selection" :editMode="editMode" :assignmentTab="'oto'" :assignment="assignment" />
                <image-section ref="image-section" :uploadedPhotos="this.localOto.photos || []" :editMode="editMode" :readOnly="readOnly" :clearable="clearable" :uploadPath="this.assignment.sr + '/oto'" @photoSelection="onPhotoSelection" :title="'Φωτογραφίες'" :zipName="this.assignment.sr + '_' + 'oto'"/>
                <v-divider class="mt-5"/>
                <issue-existance-field
                    ref="malfunction-section"
                    :label="'Βλάβη / Πρόβλημα'"
                    :photoLabel="'Φωτογραφίες Βλάβης'"
                    :check="hasMalfunction"
                    :comments="localOto.malfunction?.comments || {}"
                    :uploadedPhotos="localOto.malfunction?.photos || []"
                    :readOnly="readOnly"
                    :clearable="clearable"
                    :editMode="editMode"
                    :uploadPath="this.assignment.sr + '/oto/malfunction'"
                    @onIssuePhotoSelection="onTroublePhotoSelection"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import FormToolbar from '@/components/FormToolbar'
    import ImageSection from '@/components/ImageSection'
    import geolocation from '@/utils/geolocation'
    import MaterialSelection from '@/components/MaterialSelection'
    import FloorStructure from '@/components/FloorStructure'
    import IssueExistanceField from '@/components/IssueExistanceField'
    import Comments from '@/components/Comments'
    import momentTimezone from 'moment-timezone'
    import CustomDatetime from '@/components/CustomDatetime'

    export default {
        name: 'OtoTab',
        components: { Alert, IssueExistanceField, Comments, CustomDatetime, FormToolbar, ImageSection, MaterialSelection, FloorStructure },
        watch: {
            assignment: {
                handler(newVal, oldVal) {
                    this.resetForm()
                },
                deep: true
            }
        },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                return (this.editMode && !this.localOto.completed && !(this.localOto.comments || this.newComment) && !this.localOto.appointmentDate) || !this.editMode
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            statuses() {
                return this.config?.oto?.statuses || []
            },
            theming() {
                return this.$store.getters.getTheming || {}
            }
        },
        data: () => {
            return {
                localOto: {
                    description: null,
                    completed: false,
                    photos: [],
                    status: null
                },
                hasMalfunction: false,
                selectedTroublePhotos: 0,
                selectedPhotos: 0,
                materialDialog: false,
                showAlert: false,
                message: null,
                dialog: false,
                type: null,
                loading: false,
                mode: null,
                readOnly: false,
                clearable: true,
                newComment: null,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                editMode: false
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            appointmentDateSelected(datetime) {
                this.$set(this.localOto, 'appointmentDate', momentTimezone(datetime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString())
            },
            onNewComment(e) {
                this.newComment = e
            },
            onTroublePhotoSelection(noOfSelectedPhotos) {
                this.selectedTroublePhotos = noOfSelectedPhotos
            },
            onUploadPhotoError(message) {
                this.setAlert(message, 'error')
            },
            onPhotoSelection(selectedPhotos) {
                this.selectedPhotos = selectedPhotos.length
            },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.clearable = false
                    this.editMode = false
                }
            },
            resetForm() {
                this.localOto = this.assignment.oto ? JSON.parse(JSON.stringify(this.assignment.oto)) : {}
                this.hasMalfunction = !!this.localOto.malfunction
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            async editAssignment() {
                this.loading = true
                const coords = await geolocation.getCoordinates()
                this.localOto.geolocation = coords
                if (!this.localOto.photos) {
                    this.localOto.photos = []
                }
                const malfunctionSection = this.$refs['malfunction-section'].getIssueValues()
                this.hasMalfunction = malfunctionSection.checked
                if (this.hasMalfunction) {
                    this.localOto.malfunction = this.localOto.malfunction || { photos: [] }
                    this.localOto.malfunction.newComment = malfunctionSection.newComment
                }

                if (this.isAdminOrCompanyCoordinator) {
                    try {
                        const deletedPhotos = await this.$refs['image-section'].deleteUploadedPhotos()
                        this.localOto.photos = deletedPhotos ? this.localOto.photos.filter(photo => !deletedPhotos.includes(photo)) : [ ...this.localOto.photos ]
                        if (this.hasMalfunction) {
                            const deletedTroubleshootingPhotos = await this.$refs['malfunction-section'].deleteUploadedPhotos()
                            this.localOto.malfunction.photos = deletedTroubleshootingPhotos ? this.localOto.malfunction.photos.filter(photo => !deletedTroubleshootingPhotos.includes(photo)) : [ ...this.localOto.malfunction.photos ]
                        }
                    } catch (error) {
                        this.setAlert(error.message, 'error')
                        this.loading = false
                        return
                    }
                }
                try {
                    const uploadedPhotos = await this.$refs['image-section'].uploadPhotos()
                    this.localOto.photos = uploadedPhotos ? this.localOto.photos.concat(uploadedPhotos) : [ ...this.localOto.photos ]
                    if (this.hasMalfunction) {
                        const uploadedTroubleshootingPhotos = await this.$refs['malfunction-section'].uploadPhotos()
                        this.localOto.malfunction.photos = uploadedTroubleshootingPhotos ? this.localOto.malfunction.photos.concat(uploadedTroubleshootingPhotos) : [ ...this.localOto.malfunction.photos ]
                    }
                } catch (error) {
                    this.setAlert(error.message, 'error')
                    this.loading = false
                    return
                }

                this.localOto.newComment = this.newComment
                if (this.config.hasStorage) {
                    this.localOto.materialsRequested = this.$refs['material-selection'].proccessMaterialRequested()
                }
                assignmentService.updateAssignmentTab('oto', this.assignment.id, { oto: this.localOto }).then((response) => {
                    this.loading = false
                    this.photoUploadProgress = 0
                    this.$refs['comments'].clear()
                    this.$refs['malfunction-section'].clear()
                    this.switchEditMode(false)
                    this.setAlert('Η ενημέρωση ΟΤΟ ήταν επιτυχημένη', 'success')
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.edit-button-wrapper {
    display: flex;
    justify-content: flex-start;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.field.completed-checkbox {
    font-weight: 800;
}

.v-card {
    padding: 0.8rem;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.first-row-wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    align-items: first baseline;
    justify-content: space-evenly;
    margin-top: 0.8rem;
}

.oto-info {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-evenly;
    width: 100%;
    padding: 0.4rem;
}

@media screen and (max-width: 461px) {
    .oto-info {
       flex-direction: column;
    }
}
</style>
